import React from "react";
import { colors } from "../components/theme";

const Loading = (props) => {
  if (!props.show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <div style={styles.spinner}>
          <div style={styles.spinnerInner}></div>
        </div>
        {props.text && (
          <p style={styles.text}>{props.text}</p>
        )}
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    backdropFilter: "blur(2px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    animation: "fadeIn 0.2s ease-out",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  },
  spinner: {
    width: "36px",
    height: "36px",
    position: "relative",
  },
  spinnerInner: {
    width: "100%",
    height: "100%",
    border: `3px solid ${colors.blueTransparent}`,
    borderTop: `3px solid ${colors.blue}`,
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  text: {
    margin: 0,
    fontSize: "13px",
    fontWeight: 500,
    color: colors.gray2,
    letterSpacing: "0.2px",
    animation: "pulse 1.5s ease-in-out infinite",
  },
};

export default Loading;
